/**
 * orga app | datentransfer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface FunktionsbereichDetail { 
    mandant_id?: string;
    modified_on_utc?: string;
    titel?: string;
    funktionsbereich_id?: string;
    explizite_freigabe_erforderlich?: boolean;
    email_benachrichtigungen_bei_bereitschaft_empfaenger?: string;
    hat_email_benachrichtigungen_bei_bereitschaft?: boolean;
    email_benachrichtigungen_bei_fehlerfall_empfaenger?: string;
    hat_email_benachrichtigungen_bei_fehlerfall?: boolean;
}

